import { noop, get } from 'lodash-es';
import { put, call, takeLatest } from 'redux-saga/effects';

import {
    cancel_payment,
    fetch_addFunds_payment_landing,
    initiate_addfunds_payment,
    fetch_addfunds_bank
} from '../../../../apis/paymentV2/addFunds';
import {
	setActionLoaderTrue,
	setActionLoaderFalse,
} from '../../../reducers/actionLoader';
import {
	setActionError,
	resetActionError,
} from '../../../reducers/actionError';
import paymentService from '../../../../services/paymentService';
import { fetchAddFundsPaymentLandingDetails, initiateAddFundsPayment, cancelAddFundsPayment, fetchAddFundsBankDetails } from '../../../reducers/paymentV2/equity';
import {
    setPaymentDetails,
    setOrderCreationData,
	setPaymentProduct,
	setPaymentFlow,
	setBankDetails,
	setPrimaryBankDetails,
} from '../../../reducers/paymentV2';
import { PAYMENT_FLOWS, PAYMENT_PRODUCT_NAMES } from '../../../../constants/payment';

function* handleFetchAddFundsPaymentLandingDetails({ payload }) {
	const { Api, params, sagaCallback = noop } = payload;
	try {
		yield put(resetActionError(fetchAddFundsPaymentLandingDetails));
		yield put(setActionLoaderTrue(fetchAddFundsPaymentLandingDetails));
		const response = yield call(fetch_addFunds_payment_landing, Api, params);
		const formatedCommonPaymentStructure = yield call(paymentService.formatEquityPaymentResponse, {data: response, productName: PAYMENT_PRODUCT_NAMES.EQUITY, paymentFlow: PAYMENT_FLOWS.ADD_FUNDS});
		const supportedBankList =  get(formatedCommonPaymentStructure, 'bank_list', []);
		const defaultSelectedBankDetails = paymentService.getPrimaryBankDetails(supportedBankList);
		yield put(setPaymentProduct(PAYMENT_PRODUCT_NAMES.EQUITY));
		yield put(setPaymentFlow(PAYMENT_FLOWS.ADD_FUNDS))
		yield put(setPaymentDetails(formatedCommonPaymentStructure));
		yield put(setBankDetails(defaultSelectedBankDetails));
		yield call(sagaCallback, response);
	} catch(e) {
		yield put(
			setActionError({
				isFetchFailed: true,
				actionName: fetchAddFundsPaymentLandingDetails,
			}),
		);
	} finally {
		yield put(setActionLoaderFalse(fetchAddFundsPaymentLandingDetails));
	}
}

function* handleCancelAddFundsPayment({ payload }) {
	const { Api, url, sagaCallback = noop } = payload;
	try {
		yield put(resetActionError(cancelAddFundsPayment));
		yield put(setActionLoaderTrue(cancelAddFundsPayment));
		const response = yield call(cancel_payment, Api, url);
		yield call(sagaCallback, response);
	} catch (error) {
		console.log('error while cancelling the order');
		yield put(
			setActionError({ isFetchFailed: true, actionName: cancelAddFundsPayment }),
		);
	} finally {
		yield put(setActionLoaderFalse(cancelAddFundsPayment));
	}
}

function* handleInitiateAddFundsPayment({payload}) {
	const {
		Api,
		url,
		params,
		sagaCallback = noop,
		paymentType = '',
		androidPackageName = '',
	} = payload;
	try {
		yield put(resetActionError(initiateAddFundsPayment));
		yield put(setActionLoaderTrue(initiateAddFundsPayment));
		const response = yield call(initiate_addfunds_payment, Api, url, params);
		yield put(setOrderCreationData(response));
		yield call(sagaCallback, response, paymentType, androidPackageName);
	} catch (error) {
		console.log('coming error while initiating the payment');
		yield put(
			setActionError({
				isFetchFailed: true,
				message: error.message,
				actionName: initiateAddFundsPayment,
			}),
		);
	} finally {
		yield put(setActionLoaderFalse(initiateAddFundsPayment));
	}
}

function* handleFetchAddFundsBankDetails({payload}) {
	const {Api} = payload;
	try {
	  yield put(resetActionError(fetchAddFundsBankDetails))	
      yield put(setActionLoaderTrue(fetchAddFundsBankDetails))
	  const response = yield call(fetch_addfunds_bank, Api);
	  const primaryBankDetails = get(response, '0', {});
      yield put(setPrimaryBankDetails(primaryBankDetails))
	} catch(e) {
      console.log('error in the addFundsBankDetails');
	  yield put(setActionError({isFetchFailed: true, actionName: fetchAddFundsBankDetails}))
	} finally {
       yield put(setActionLoaderFalse(fetchAddFundsBankDetails));
	}
}

export default function* addFundsPaymentSaga() {
	yield takeLatest(fetchAddFundsPaymentLandingDetails.toString(), handleFetchAddFundsPaymentLandingDetails);
	yield takeLatest(initiateAddFundsPayment.toString(), handleInitiateAddFundsPayment);
	yield takeLatest(cancelAddFundsPayment.toString(), handleCancelAddFundsPayment);
	yield takeLatest(fetchAddFundsBankDetails.toString(), handleFetchAddFundsBankDetails)
}
